export default __webpack_public_path__ + "static/screeny-110-gc-3-8576c01f74daea00d449fa4aaefb5bfc.jpg";